import { useMemo } from 'react';
import { Box } from '@mantine/core';
import { useSelector } from 'react-redux';

import { ServiceConstants } from 'constant';

import { IRootState } from 'config/redux';
import Modal from './base';
import Button from '../button/standard';
import Text from '../text';
import { TFunction } from 'i18next';

const { REQUEST_PENDING } = ServiceConstants;

interface ConfirmModalProps {
  opened: boolean;
  titleKey: string;
  descriptionKey: string;
  actionKey: string;
  requestId: string;
  onClose: (val: boolean) => void;
  onSubmit: () => void;
  t: TFunction
}

const ConfirmModal = ({ opened, requestId, onSubmit, onClose, titleKey, descriptionKey, actionKey, t }: ConfirmModalProps) => {

  const serviceObject = useSelector((state: IRootState) => state.service.object[requestId])
  const isLoading = useMemo(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);

  return (
    <Modal opened={opened} onClose={() => onClose(false)} title={t(titleKey)}>
      <Text>{t(descriptionKey)}</Text>
      <Box mt={40}>
        <Button
          fullWidth={true}
          disabled={isLoading}
          loading={isLoading}
          onClick={onSubmit}
        >
          {t(actionKey)}
        </Button>
      </Box>
    </Modal>
  )
}

export default ConfirmModal;